export const contactMethods = {
  email: 'email',
  url: 'url',
  emailAndUrl: 'email_and_url',
}
